import React, {
  useContext,
  useMemo,
  useCallback,
  useState,
  useEffect,
} from 'react';
import {
  BusinessDataFormContext,
  IBusinessDataFormContext,
} from '../../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/BusinessDataForm';
import {
  attesteraFakturadel,
  getMinAttestTyp,
  isAttesteraButtonDisabled,
  isSaveButtonDisabled,
  getAktuellFakturaAttest,
  sortFakturattestByAttestant,
  isAutomaticallyAdded,
} from '../../Utils/FakturadelUtils';
import FakturadelContext, {
  IKonteringsforslagUpdateObject,
  IFakturaDelContext,
  IStandinInfo,
} from './FakturaDelContext';
import {
  mergeBusinessDataFormValues,
  parseText,
  IFieldValidations,
} from '../../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/Utils/BusinessDataFormUtils';
import {
  FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Konteringsforslag_All,
  FakturaDelQuery_node_TEDLRFakturaDel__Associations_Fakturaattest_All,
  FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Fakturadel,
} from '../../Queries/_QueryTypes/FakturaDelQuery';
import {
  getAutochangedKonteringsforslagList,
  getKostnadsBelopp,
} from '../Kontering/Utils/KonteringUtils';
import {
  TEDLRFakturaAttestAttestTypEnum,
  TEDLRFakturaDelAttestMinaStatusEnum,
  TEDLRAttestmeddelandeAVSANDAR_TYPEnum,
  TEDLRAttestmeddelandeMOTTAGAR_TYPEnum,
  TEDLRFakturaAttestTYPEnum,
  TEDInputLRKonteringsForslagUpdateValues,
  TEDLRFakturabildFORMATEnum,
} from '../../../../../../../globalQueryTypes';
import KonteringContext from '../../../../../_Common/Components/KonteringManager/KonteringContext';
import {
  FakturaDelType__Associations_Faktura__Associations_Attestmeddelande_All,
  FakturaDelType__Associations_Faktura__Associations_Fakturasidor,
} from '../../Queries/_QueryTypes/FakturaDelType';
import {
  FormUpdateAssociatonType,
  getFormUpdateValue,
} from '../../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/Utils/BusinessDataFormValueUtils';
import { AllCertifiers_db_LRAttestratt_All } from '../FakturaAttestHandleCertifiersModal/Queries/_QueryTypes/AllCertifiers';
import EDKeybind from '../../../../../../../BaseComponents/Keybinds/EDKeybind';
import AttestMessageContext from '../AttestMessageContext/AttestMessageContext';
import { LoginStateContext } from '../../../../../../Login/Contexts/LoginStateContext/LoginStateContext';
import { FakturaattestWrapperContext } from '../../../../Rutiner/FakturaDel/Contexts/FakturaattestWrapperContext';
import mergeSort from '../../../../../../../Utils/mergeSort';
import { Tillaggsinfokod } from '../Kontering/Components/Tillaggsinfo/Utils/TillaggsinfoUtils';
import { IValues } from '../../../../../_StandardRutin/Mutations/ObjectMutations/ObjectUpdateMutationBase';
import { NEWLY_ADDED_ID_PREFIX_FOR_UPDATE } from '../../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/Const/BusinessDataFormConst';

export type GetKostnadsBeloppFormValueType = (
  konteringsforslagId: string | undefined,
  konteringsforslagDebet: number | null | undefined,
  konteringsforslagKredit: number | null | undefined,
  setNewBeloppChange: (id: string | null) => void,
  radtyp: number | null | undefined,
  beloppInklMoms: number,
  beloppExklMoms: number,
  ingMomsSats: number | null | undefined,
  avdragsratt: number,
  customIngMomsBelopp: number | null | undefined,
  utlandskMomsSats: number | null | undefined,
  utlandskMomsBelopp: number | null | undefined
) => IValues;

interface IProps {}

export const AUTOMATICALLY_ADDED_VALUE_PREFIX = `${NEWLY_ADDED_ID_PREFIX_FOR_UPDATE}autoadded`;

export const konteringsforslagWithoutDeletedKontodelar = (
  konteringsforslag: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Konteringsforslag_All
) => {
  return {
    ...konteringsforslag,
    _Associations: {
      ...konteringsforslag._Associations,
      Kontodel1: konteringsforslag.KONTOID_1
        ? konteringsforslag._Associations?.Kontodel1
        : null,
      Kontodel2: konteringsforslag.KONTOID_2
        ? konteringsforslag._Associations?.Kontodel2
        : null,
      Kontodel3: konteringsforslag.KONTOID_3
        ? konteringsforslag._Associations?.Kontodel3
        : null,
      Kontodel4: konteringsforslag.KONTOID_4
        ? konteringsforslag._Associations?.Kontodel4
        : null,
      Kontodel5: konteringsforslag.KONTOID_5
        ? konteringsforslag._Associations?.Kontodel5
        : null,
      Kontodel6: konteringsforslag.KONTOID_6
        ? konteringsforslag._Associations?.Kontodel6
        : null,
      Kontodel7: konteringsforslag.KONTOID_7
        ? konteringsforslag._Associations?.Kontodel7
        : null,
      Kontodel8: konteringsforslag.KONTOID_8
        ? konteringsforslag._Associations?.Kontodel8
        : null,
      Kontodel9: konteringsforslag.KONTOID_9
        ? konteringsforslag._Associations?.Kontodel9
        : null,
      Kontodel10: konteringsforslag.KONTOID_10
        ? konteringsforslag._Associations?.Kontodel10
        : null,
    },
  };
};

export const undoFakturaAttest = (
  businessDataFormContext: IBusinessDataFormContext<any>,
  editMenuOnCancel?: (() => void) | undefined
) => {
  businessDataFormContext?.formStateDispatch({ type: 'CANCEL' });
  editMenuOnCancel?.();
};

export const isUndoFakturaAttestButtonDisabled = (
  businessDataFormContext: IBusinessDataFormContext<any>
): boolean => {
  let result = false;
  if (businessDataFormContext?.directEditMode) {
    result =
      businessDataFormContext.mutationLoading ||
      !businessDataFormContext.formState.formHasChanged;
  } else {
    if (businessDataFormContext?.mutationLoading) {
      result = businessDataFormContext?.mutationLoading;
    } else {
      result = false;
    }
  }
  return result;
};
const FakturaDelContextManager: React.FC<
  React.PropsWithChildren<IProps>
> = props => {
  const formContext = useContext(BusinessDataFormContext);
  const formStateDispatch = formContext?.formStateDispatch;
  const konteringContext = useContext(KonteringContext);
  const attestMessageContext = useContext(AttestMessageContext);
  const setHaveAttesterat = attestMessageContext.setHaveAttesterat;
  const setMessageEditModeID = attestMessageContext.setMessageEditModeID;
  const loginStateContext = useContext(LoginStateContext);
  const reservForContext = useContext(FakturaattestWrapperContext);
  const [deletedKFs, setDeletedKFs] = useState<string[]>();
  const [activeKF, setActiveKF] = useState<string>('');

  // Nollställ deletedKFs när man återställer en fakturadel.
  useEffect(() => {
    if (!formContext?.formState.formHasChanged) {
      setDeletedKFs([]);
    }
  }, [formContext?.formState.formHasChanged]);

  const dataMergedWithChanges = useMemo(
    () =>
      mergeBusinessDataFormValues(
        parseText(formContext?.data),
        parseText(formContext?.formState.values ?? {})
      ),
    [formContext?.data, formContext?.formState.values]
  );

  const jagAttesterar = useMemo(
    () =>
      [
        TEDLRFakturaDelAttestMinaStatusEnum.MOTTAGNINGSATTESTERAS,
        TEDLRFakturaDelAttestMinaStatusEnum.BESLUTSATTESTERAS,
        TEDLRFakturaDelAttestMinaStatusEnum.KONTROLLATTESTERAS,
      ].includes(dataMergedWithChanges.AttestMinaStatus),
    [dataMergedWithChanges]
  );

  const minAttestTyp = useMemo(
    () => (formContext?.data ? getMinAttestTyp(formContext?.data) : null),
    [formContext?.data]
  );

  const minFakturaAttest = useMemo(() => {
    return getAktuellFakturaAttest(
      dataMergedWithChanges?._Associations?.Fakturaattest ?? [],
      reservForContext.reservForData,
      loginStateContext.sign,
      minAttestTyp
    );
  }, [
    dataMergedWithChanges?._Associations?.Fakturaattest,
    reservForContext.reservForData,
    loginStateContext.sign,
    minAttestTyp,
  ]);

  const beslutsAttestanterAllaFakturadelar: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Fakturaattest_All[] =
    useMemo(
      () =>
        dataMergedWithChanges?._Associations?.Faktura?._Associations?.Fakturadel?.flatMap(
          (fakturadel: any) => fakturadel?._Associations?.Fakturaattest ?? []
        ).filter(
          (attest: any) =>
            attest?.AttestTyp === TEDLRFakturaAttestAttestTypEnum.BESLUTSATTEST
        ) ?? [],

      [dataMergedWithChanges]
    );

  const konteringsforslag: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Konteringsforslag_All[] =
    useMemo(() => {
      return mergeSort(
        dataMergedWithChanges?._Associations?.Faktura?._Associations?.Konteringsforslag?.filter(
          (kf: any) =>
            !formContext?.formState.values?._Associations?.Faktura_Values?._Associations?.Konteringsforslag_Delete_Values?.some(
              (deletedKf: any) => deletedKf.id === kf.id
            )
        ).map(konteringsforslagWithoutDeletedKontodelar) ?? [],
        (a, b) => {
          if (a.SORTERINGS_NR && b.SORTERINGS_NR) {
            if (a.SORTERINGS_NR > b.SORTERINGS_NR) {
              return 1;
            } else if (b.SORTERINGS_NR > a.SORTERINGS_NR) {
              return -1;
            } else {
              return 0;
            }
          }
          return 0;
        }
      );
    }, [
      dataMergedWithChanges?._Associations?.Faktura?._Associations
        ?.Konteringsforslag,
      formContext?.formState.values,
    ]);

  const isKobFaktura: boolean = useMemo(() => {
    return formContext?.formState.currentValues?._Associations?.Faktura?._Associations?.Fakturasidor?.some(
      (
        fakturasida: FakturaDelType__Associations_Faktura__Associations_Fakturasidor
      ) => fakturasida.FORMAT === TEDLRFakturabildFORMATEnum.KOB
    );
  }, [
    formContext?.formState.currentValues?._Associations?.Faktura?._Associations
      ?.Fakturasidor,
  ]);

  const getOriginKonteringsforslag = useCallback(
    (
      konteringsforslagId: string
    ): FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Konteringsforslag_All | null => {
      return formContext?.data?._Associations?.Faktura?._Associations?.Konteringsforslag_All?.find(
        (
          konteringsforslag: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Konteringsforslag_All
        ) => konteringsforslag.id === konteringsforslagId
      );
    },
    [formContext?.data]
  );

  const attestMessages: FakturaDelType__Associations_Faktura__Associations_Attestmeddelande_All[] =
    useMemo(() => {
      return (
        dataMergedWithChanges?._Associations?.Faktura?._Associations?.Attestmeddelande?.filter(
          (message: any) =>
            !formContext?.formState.values?._Associations?.Faktura_Values?._Associations?.Attestmeddelande_Delete_Values?.some(
              (deletedMessage: any) => deletedMessage.id === message.id
            )
        ) ?? []
      );
    }, [dataMergedWithChanges, formContext]);

  type MessageObject = {
    id: string;
    MEDDELANDE: string;
    AVSANDAR_TYP: TEDLRAttestmeddelandeAVSANDAR_TYPEnum;
    MOTTAGAR_TYP: TEDLRAttestmeddelandeMOTTAGAR_TYPEnum;
    TID?: string;
  };

  const getAttestMessageUpdateValue = useCallback(
    (
      message: string,
      id: string,
      time?: string,
      reciverID?: string,
      mottagarTyp?: TEDLRAttestmeddelandeMOTTAGAR_TYPEnum
    ): FormUpdateAssociatonType[][] => {
      const isAdd = isAutomaticallyAdded({ id });
      const messageArray: FormUpdateAssociatonType[][] = [];

      const mottagarTypFinal =
        mottagarTyp === TEDLRAttestmeddelandeMOTTAGAR_TYPEnum.ADMINISTRATOR
          ? TEDLRAttestmeddelandeMOTTAGAR_TYPEnum.ADMINISTRATOR
          : reciverID != undefined && reciverID !== ''
          ? TEDLRAttestmeddelandeMOTTAGAR_TYPEnum.ATTESTANT
          : TEDLRAttestmeddelandeMOTTAGAR_TYPEnum.ALLA;

      let messageObject: MessageObject = {
        id: id,
        MEDDELANDE: message,
        AVSANDAR_TYP: TEDLRAttestmeddelandeAVSANDAR_TYPEnum.ATTESTANT,
        MOTTAGAR_TYP: mottagarTypFinal,
      };

      if (time) {
        messageObject = {
          id: id,
          MEDDELANDE: message,
          AVSANDAR_TYP: TEDLRAttestmeddelandeAVSANDAR_TYPEnum.ATTESTANT,
          MOTTAGAR_TYP: mottagarTypFinal,
          TID: time,
        };
      }

      const messageValue: FormUpdateAssociatonType = {
        operation: !isAdd ? 'Update_Values' : 'Add_Values',
        id: messageObject.id,
        associationName: 'Attestmeddelande',
        values: isAdd
          ? messageObject
          : { id: messageObject.id, MEDDELANDE: messageObject.MEDDELANDE },
      };

      if (isAdd) {
        messageArray.push([
          'Faktura',
          messageValue,
          {
            operation: 'Ref',
            associationName: 'AvsandarAttestratt',
            values: {
              id: minFakturaAttest.isReserv
                ? minFakturaAttest.reservAttestratt.id
                : minFakturaAttest.ordinarieAttestratt.id,
              _version: 1,
            },
          },
        ]);

        if (
          reciverID &&
          mottagarTypFinal === TEDLRAttestmeddelandeMOTTAGAR_TYPEnum.ATTESTANT
        ) {
          messageArray.push([
            'Faktura',
            messageValue,
            {
              operation: 'Ref',
              associationName: 'MottagarAttestratt',
              values: {
                id: reciverID,
                _version: 1,
              },
            },
          ]);
        }
      } else {
        messageArray.push(['Faktura', messageValue]);
      }

      return messageArray;
    },
    [
      minFakturaAttest.isReserv,
      minFakturaAttest.ordinarieAttestratt.id,
      minFakturaAttest.reservAttestratt.id,
    ]
  );

  const addAttestMessage = useCallback(
    (
      message: string,
      id: string,
      time?: string,
      reciverID?: string,
      mottagarTyp?: TEDLRAttestmeddelandeMOTTAGAR_TYPEnum
    ) => {
      formStateDispatch?.({
        type: 'UPDATE',
        value: getFormUpdateValue(
          getAttestMessageUpdateValue(
            message,
            id,
            time,
            reciverID,
            mottagarTyp
          ),
          formContext?.data
        ),
      });
    },
    [formContext?.data, formStateDispatch, getAttestMessageUpdateValue]
  );

  const deleteOrUndoAttestMessage = useCallback(
    (messageID: string, undoToLatestMessage?: string) => {
      if (messageID.startsWith(AUTOMATICALLY_ADDED_VALUE_PREFIX)) {
        // Ny association
        const messageIndex: number =
          formContext?.formState?.values?._Associations?.Faktura_Values?._Associations?.Attestmeddelande_Add_Values?.findIndex(
            (message: any) => message.id === messageID
          );

        formStateDispatch?.({
          type: 'DELETE_NEW_ASSOCIATION',
          path: [
            '_Associations',
            'Faktura_Values',
            '_Associations',
            'Attestmeddelande_Add_Values',
            messageIndex,
          ],
        });
      } else {
        // Existerande, sparad, association
        if (undoToLatestMessage) {
          formContext?.update([
            'Faktura',
            {
              operation: 'Update_Values',
              associationName: 'Attestmeddelande',
              id: messageID,
              values: { MEDDELANDE: undoToLatestMessage },
            },
          ]);
        } else {
          formContext?.update([
            'Faktura',
            {
              operation: 'Delete_Values',
              associationName: 'Attestmeddelande',
              id: messageID,
            },
          ]);
        }
      }
    },
    [formContext, formStateDispatch]
  );

  const readMessage = useCallback(
    (messageID: string) => {
      let updateValues: FormUpdateAssociatonType[] = [];
      const reservAttestratt = minFakturaAttest.isReserv
        ? minFakturaAttest.reservAttestratt
        : undefined;
      const ordinarieAttestratt = minFakturaAttest.ordinarieAttestratt;
      const today = new Date();

      const values = {
        DATUM: today.toLocaleString('sv-SE'),
      };

      updateValues.push({
        operation: 'Update_Values',
        id: messageID,
        associationName: 'Attestmeddelande',
      });

      updateValues.push({
        operation: 'Add_Values',
        associationName: 'Kvittenser',
        id: AUTOMATICALLY_ADDED_VALUE_PREFIX + '_' + messageID,
        values: values,
      });

      formContext?.update([
        'Faktura',
        ...updateValues,
        {
          operation: 'Ref',
          associationName: 'Attestratt',
          values: {
            id: ordinarieAttestratt.id,
            _version: 1,
          },
        },
      ]);

      if (reservAttestratt) {
        formContext?.update([
          'Faktura',
          ...updateValues,
          {
            operation: 'Ref',
            associationName: 'ReservAttestratt',
            values: {
              id: reservAttestratt.id,
              _version: 1,
            },
          },
        ]);
      }
    },
    [minFakturaAttest, formContext]
  );

  const addFakturaattest = useCallback(
    (
      addedAttestanter: AllCertifiers_db_LRAttestratt_All[],
      certificateType: TEDLRFakturaAttestAttestTypEnum
    ): FormUpdateAssociatonType[][] => {
      const returnValues = addedAttestanter.map(newValue => {
        const ID = newValue.id;

        const updateObject: FormUpdateAssociatonType = {
          operation: 'Add_Values',
          id:
            AUTOMATICALLY_ADDED_VALUE_PREFIX +
            `_attest_${newValue._Associations?.Attestant?.SIGNATUR?.toLowerCase()}_${
              newValue._Associations?.Attestomrade?.KOD ?? ''
            }`,
          associationName: 'Fakturaattest',
          values: {
            id:
              AUTOMATICALLY_ADDED_VALUE_PREFIX +
              `_${newValue._Associations?.Attestant?.SIGNATUR?.toLowerCase()}_${
                newValue._Associations?.Attestomrade?.KOD ?? ''
              }` +
              certificateType,
            TYP:
              certificateType === TEDLRFakturaAttestAttestTypEnum.KONTROLLATTEST
                ? TEDLRFakturaAttestAttestTypEnum.BESLUTSATTEST
                : certificateType,
            KONTROLLATTEST:
              certificateType ===
              TEDLRFakturaAttestAttestTypEnum.KONTROLLATTEST,
            STATUS: 'UTDELAD',
            STATUS_DATUM: new Date().toLocaleDateString('sv-se'),
            STATUS_TID: new Date().toLocaleTimeString('sv-se'),
          },
        };

        const refObject: FormUpdateAssociatonType = {
          operation: 'Ref',
          id:
            AUTOMATICALLY_ADDED_VALUE_PREFIX +
            `_ref_${newValue._Associations?.Attestant?.SIGNATUR?.toLowerCase()}_${
              newValue._Associations?.Attestomrade?.KOD ?? ''
            }` +
            certificateType,
          associationName: 'Attestratt',
          values: {
            id: ID,
          },
        };

        return [updateObject, refObject];
      });
      return returnValues;
    },
    []
  );

  const deleteFakturaattest = useCallback(
    (
      deletedAttestanter: AllCertifiers_db_LRAttestratt_All[],
      certificateType: String
    ): FormUpdateAssociatonType[][] => {
      const returnValues: FormUpdateAssociatonType[][] = deletedAttestanter.map(
        object => {
          const attestData =
            dataMergedWithChanges?._Associations?.Fakturaattest?.find(
              (
                attest: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Fakturaattest_All
              ) =>
                attest.AttestantSign ===
                  object._Associations?.Attestant?.SIGNATUR &&
                attest.AttestTyp === certificateType &&
                attest._Associations?.Attestratt?._Associations?.Attestomrade
                  ?.KOD === object._Associations.Attestomrade?.KOD
            );

          const deleteObject: FormUpdateAssociatonType = {
            operation: 'Delete_Values',
            associationName: 'Fakturaattest',
            id: attestData.id,
          };

          return [deleteObject];
        }
      );
      return returnValues;
    },
    [dataMergedWithChanges]
  );

  /** Tar bort ett konteringsförslag, antingen ett redan existerande eller ett som blivit tillagd av oss i denna session */
  const deleteKonteringsforslag = useCallback(
    (
      newBeloppChanged: string | null,
      konteringsforslagId: string,
      setNewBeloppChangedId: (
        value: React.SetStateAction<string | null>
      ) => void,
      ignoreFormHasChanged?: boolean
    ) => {
      if (konteringsforslagId.startsWith(AUTOMATICALLY_ADDED_VALUE_PREFIX)) {
        // Ny association
        const konteringSaknasForslagIndex: number =
          formContext?.formState?.values?._Associations?.Faktura_Values?._Associations?.Konteringsforslag_Add_Values?.findIndex(
            (kf: any) =>
              konteringsforslagId === kf.id &&
              (newBeloppChanged == null || kf.id !== newBeloppChanged)
          );

        formStateDispatch?.({
          type: 'DELETE_NEW_ASSOCIATION',
          path: [
            '_Associations',
            'Faktura_Values',
            '_Associations',
            'Konteringsforslag_Add_Values',
            konteringSaknasForslagIndex,
          ],
        });
      } else {
        // Existerande, sparad, association
        const konteringForslagIndex: number =
          formContext?.formState?.values?._Associations?.Faktura_Values?._Associations?.Konteringsforslag_Update_Values?.findIndex(
            (kf: any) => kf.id === konteringsforslagId
          );

        if (konteringForslagIndex !== -1) {
          formStateDispatch?.({
            type: 'DELETE_NEW_ASSOCIATION',
            path: [
              '_Associations',
              'Faktura_Values',
              '_Associations',
              'Konteringsforslag_Update_Values',
              konteringForslagIndex,
            ],
          });
        }
        setDeletedKFs(
          deletedKFs
            ? [...deletedKFs, konteringsforslagId]
            : [konteringsforslagId]
        );

        formContext?.update(
          [
            'Faktura',
            {
              operation: 'Delete_Values',
              associationName: 'Konteringsforslag',
              id: konteringsforslagId,
            },
          ],
          ignoreFormHasChanged
        );
      }
    },
    [formContext, deletedKFs, formStateDispatch]
  );

  /** Uppdaterar ett konteringsförslag med informationen i kontforslagUpdateObj */
  const addOrUpdateKonteringsforslag = useCallback(
    (
      kontforslagUpdateObj: IKonteringsforslagUpdateObject,
      isAdded: boolean,
      associatedObject: FormUpdateAssociatonType[],
      ignoreFormHasChanged?: boolean
    ) => {
      const { _Associations, ...objectWithoutAssociations } =
        kontforslagUpdateObj;
      const object = kontforslagUpdateObj._Associations
        ? kontforslagUpdateObj
        : objectWithoutAssociations;

      if (associatedObject.length > 0) {
        formContext?.update(
          [
            'Faktura',
            {
              operation: isAdded ? 'Add_Values' : 'Update_Values',
              id: object.id,
              associationName: 'Konteringsforslag',
              values: object,
            },
            ...associatedObject,
          ],
          ignoreFormHasChanged
        );
      } else {
        formContext?.update(
          [
            'Faktura',
            {
              operation: isAdded ? 'Add_Values' : 'Update_Values',
              id: object.id,
              associationName: 'Konteringsforslag',
              values: object,
            },
          ],
          ignoreFormHasChanged
        );
      }
    },
    [formContext]
  );

  const getAttestanter = useCallback(
    (
      type: TEDLRFakturaAttestAttestTypEnum
    ): FakturaDelQuery_node_TEDLRFakturaDel__Associations_Fakturaattest_All[] =>
      mergeSort<FakturaDelQuery_node_TEDLRFakturaDel__Associations_Fakturaattest_All>(
        (
          dataMergedWithChanges?._Associations
            ?.Fakturaattest as FakturaDelQuery_node_TEDLRFakturaDel__Associations_Fakturaattest_All[]
        )?.filter(
          (
            fa: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Fakturaattest_All
          ) => fa.AttestTyp === type
        ) ?? [],
        sortFakturattestByAttestant
      ),
    [dataMergedWithChanges]
  );

  const getAllAttestanter = useCallback(
    (): FakturaDelQuery_node_TEDLRFakturaDel__Associations_Fakturaattest_All[] =>
      mergeSort(
        (dataMergedWithChanges?._Associations
          ?.Fakturaattest as FakturaDelQuery_node_TEDLRFakturaDel__Associations_Fakturaattest_All[]) ??
          [],
        (a, b) => sortFakturattestByAttestant(a, b)
      ),
    [dataMergedWithChanges]
  );

  const allAttestanterOnAllParts: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Fakturaattest_All[] =
    useMemo(
      () =>
        dataMergedWithChanges?._Associations?.Faktura?._Associations?.Fakturadel?.flatMap(
          (curr: any) => curr?._Associations?.Fakturaattest
        ) ?? [],

      [dataMergedWithChanges]
    );

  const innehallerFleraFakturadelar: boolean =
    (dataMergedWithChanges?._Associations?.Faktura?._Associations?.Fakturadel
      ?.length ?? 0) > 1;

  const getFakturadel = useCallback(
    (
      fakturaattest: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Fakturaattest_All
    ):
      | FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Fakturadel
      | undefined => {
      const fakturadel:
        | FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Fakturadel
        | undefined =
        dataMergedWithChanges?._Associations?.Faktura?._Associations?.Fakturadel?.find(
          (
            del: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Fakturadel
          ) =>
            del._Associations?.Fakturaattest?.find(
              attest => attest.id === fakturaattest.id
            )
        );

      return fakturadel;
    },
    [dataMergedWithChanges?._Associations?.Faktura?._Associations?.Fakturadel]
  );

  const getAktuellFakturadel = useCallback(():
    | FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Fakturadel
    | undefined => {
    const fakturadel:
      | FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Fakturadel
      | undefined =
      dataMergedWithChanges?._Associations?.Faktura?._Associations?.Fakturadel?.find(
        (
          del: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Fakturadel
        ) => del.id === dataMergedWithChanges.id
      );
    return fakturadel;
  }, [
    dataMergedWithChanges?._Associations?.Faktura?._Associations?.Fakturadel,
    dataMergedWithChanges.id,
  ]);

  const beslutsattestByKonteringsforslag = useCallback(
    (
      konteringsforslag: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Konteringsforslag_All | null
    ) => {
      return (
        beslutsAttestanterAllaFakturadelar?.find(
          (fa: any) =>
            fa.id === konteringsforslag?._Associations?.Fakturaattest?.id
        ) ?? null
      );
    },
    [beslutsAttestanterAllaFakturadelar]
  );

  const setBeslutsattestant = useCallback(
    (
      konteringsforslag: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Konteringsforslag_All,
      fakturaattest: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Fakturaattest_All | null,
      isAdded: boolean,
      ignoreFormHasChanged?: boolean
    ) => {
      formContext?.update(
        [
          'Faktura',
          {
            associationName: 'Konteringsforslag',
            operation: isAdded ? 'Add_Values' : 'Update_Values',
            id: konteringsforslag.id,
          },
          {
            associationName: 'Fakturaattest',
            operation: 'Ref',
            values: fakturaattest?.id ? { id: fakturaattest.id } : null,
          },
        ],
        ignoreFormHasChanged
      );
    },

    [formContext]
  );

  const isBeslutsattestantChanged = useCallback(
    (
      konteringsforslag: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Konteringsforslag_All
    ) => {
      const current = konteringsforslag['_Associations']?.['Fakturaattest'];

      const data: TEDInputLRKonteringsForslagUpdateValues | undefined =
        formContext?.data?._Associations?.['Faktura']?.['_Associations']?.[
          'Konteringsforslag_All'
        ]?.find(
          (x: TEDInputLRKonteringsForslagUpdateValues) =>
            x.id === konteringsforslag.id
        )?.['_Associations']?.['Fakturaattest'];

      const autochangedKonteringsforslagsList =
        getAutochangedKonteringsforslagList(formContext?.formState.autoValues);

      const listOfAutoAddedAttestIDs = autochangedKonteringsforslagsList.map(
        (kf: any) => kf._Associations?.Fakturaattest_Ref?.id
      );

      return (
        !listOfAutoAddedAttestIDs.includes(current?.id) &&
        current?.id !== data?.id
      );
    },
    [formContext]
  );

  const setBelopp = useCallback(
    (
      konteringsforslagId: string,
      newValue: string,
      isAdded: boolean,
      saknarKontering: boolean,
      setNewBeloppChange: (id: string | null) => void,
      validationErrorMessage?: IFieldValidations
    ) => {
      let value = parseFloat(newValue);

      setNewBeloppChange(konteringsforslagId);

      if (Number.isNaN(value)) {
        value = 0;
      }
      formContext?.update([
        'Faktura',
        {
          associationName: 'Konteringsforslag',
          operation: isAdded ? 'Add_Values' : 'Update_Values',
          id: konteringsforslagId,
          values: {
            DEBET: value >= 0 ? Math.abs(value) : 0.0,
            KREDIT: value < 0 ? Math.abs(value) : 0.0,
          },
        },
      ]);
    },
    [formContext]
  );

  const setBeloppExklMoms = useCallback(
    (
      konteringsforslagId: string,
      newValue: string,
      isAdded: boolean,
      setNewBeloppChange: (id: string | null) => void
    ) => {
      let value = parseFloat(newValue);

      setNewBeloppChange(konteringsforslagId);

      if (Number.isNaN(value)) {
        value = 0;
      }
      formContext?.update([
        'Faktura',
        {
          associationName: 'Konteringsforslag',
          operation: isAdded ? 'Add_Values' : 'Update_Values',
          id: konteringsforslagId,
          values: {
            BELOPP_EXKL_MOMS: value,
          },
        },
      ]);
    },
    [formContext]
  );

  const getBeloppInklMomsFormValue = useCallback(
    (
      konteringsforslagId: string,
      newValue: string,
      setNewBeloppChange: (id: string | null) => void
    ): IValues => {
      let value = parseFloat(newValue);

      setNewBeloppChange(konteringsforslagId);

      if (Number.isNaN(value)) {
        value = 0;
      }

      const newFormValue: IValues = {
        BELOPP_INKL_MOMS: value,
      };
      return newFormValue;
    },
    []
  );

  const getKostnadsBeloppFormValue: GetKostnadsBeloppFormValueType =
    useCallback(
      (
        konteringsforslagId: string | undefined,
        konteringsforslagDebet: number | null | undefined,
        konteringsforslagKredit: number | null | undefined,
        setNewBeloppChange: (id: string | null) => void,
        radtyp: number | null | undefined,
        beloppInklMoms: number,
        beloppExklMoms: number,
        ingMomsSats: number | null | undefined,
        avdragsratt: number,
        customIngMomsBelopp: number | null | undefined,
        utlandskMomsSats: number | null | undefined,
        utlandskMomsBelopp: number | null | undefined
      ): IValues => {
        if (konteringsforslagId) {
          setNewBeloppChange(konteringsforslagId);

          const kostnad: number = getKostnadsBelopp(
            radtyp,
            beloppInklMoms,
            beloppExklMoms,
            ingMomsSats,
            avdragsratt,
            customIngMomsBelopp,
            utlandskMomsSats,
            utlandskMomsBelopp
          );

          if (
            radtyp === 1 ||
            radtyp === 3 ||
            radtyp === 4 ||
            radtyp === 5 ||
            radtyp === 6
          ) {
            const newFormValues: IValues = {
              DEBET: kostnad >= 0 ? Math.abs(kostnad) : 0.0,
              KREDIT: kostnad < 0 ? Math.abs(kostnad) : 0.0,
            };
            return newFormValues;
          }
        }
        return {
          DEBET: konteringsforslagDebet ?? 0.0,
          KREDIT: konteringsforslagKredit ?? 0.0,
        };
      },
      []
    );

  const isBeloppChanged = useCallback(
    (
      konteringsforslag: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Konteringsforslag_All
    ) => {
      const current =
        konteringsforslag.DEBET >= 0
          ? konteringsforslag.DEBET
          : konteringsforslag.KREDIT ?? 0;
      const data: TEDInputLRKonteringsForslagUpdateValues | undefined =
        formContext?.data?._Associations?.['Faktura']?.['_Associations']?.[
          'Konteringsforslag_All'
        ]?.find(
          (x: TEDInputLRKonteringsForslagUpdateValues) =>
            x.id === konteringsforslag.id
        );
      const compareValue: Number =
        data?.DEBET >= 0 ? data?.DEBET : data?.KREDIT ?? 0;

      const autochangedKonteringsforslagsList =
        getAutochangedKonteringsforslagList(formContext?.formState.autoValues);

      const listOfAutoAddedAttest = autochangedKonteringsforslagsList.filter(
        (kf: any) => kf.id === konteringsforslag.id
      );

      const autoAddedValues: number[] = listOfAutoAddedAttest.map(
        (elem: any) => {
          return elem.DEBET >= 0 ? elem.DEBET : elem.KREDIT ?? 0;
        }
      );

      return !autoAddedValues.includes(current) && current !== compareValue;
    },
    [formContext]
  );

  const setKontodel = useCallback(
    (
      konteringsforslagId: string,
      newValue: string,
      lopnr: number,
      kodplanId: string,
      bokfDatum: Date,
      isAdded: boolean,
      isFIActive: boolean,
      isFakturaBeloppLowerThanPeriodiseringBeloppEnhet: boolean
    ) => {
      let values: any;
      const wantedKoddel =
        konteringContext.konteringUtils.getKontodelByKontodel(
          kodplanId,
          lopnr,
          newValue,
          bokfDatum
        );

      if (newValue == null) {
        if (lopnr === 1) {
          values = {
            [`KONTOID_${lopnr}`]: null,
            [`ORDNINGS_NR_${lopnr}`]: null,
            TILLAGGSINFO_KOD: wantedKoddel?.tillaggsinfo?.kod ?? null,
          };
        } else {
          values = {
            [`KONTOID_${lopnr}`]: null,
            [`ORDNINGS_NR_${lopnr}`]: null,
          };
        }

        formContext?.update([
          'Faktura',
          {
            associationName: 'Konteringsforslag',
            operation: isAdded ? 'Add_Values' : 'Update_Values',
            id: konteringsforslagId,
            values: values,
          },
          {
            associationName: `Kontodel${lopnr}`,
            operation: 'Ref',
            values: null,
          },
        ]);
      } else {
        if (lopnr === 1) {
          values = {
            [`KONTOID_${lopnr}`]: wantedKoddel?.ordningsNr ?? null,
            TILLAGGSINFO_KOD: wantedKoddel?.tillaggsinfo?.kod ?? null,
          };

          if (
            wantedKoddel?.tillaggsinfo?.kod === Tillaggsinfokod.FI &&
            !isFIActive
          ) {
            values = {
              [`KONTOID_${lopnr}`]: wantedKoddel?.ordningsNr ?? null,
            };
          }
          //Ta bort periodiseringen om man väljer en koddel som inte är ett undantag för beloppsgränsen
          if (
            isFakturaBeloppLowerThanPeriodiseringBeloppEnhet &&
            !wantedKoddel?.undantagPeriodisering
          ) {
            values = {
              ...values,
              PERIODISERAD: false,
              PER_FROM_DATUM: null,
              PER_TOM_DATUM: null,
            };
          }
        } else {
          values = {
            [`KONTOID_${lopnr}`]: wantedKoddel?.ordningsNr ?? null,
          };
        }
        formContext?.update([
          'Faktura',
          {
            associationName: 'Konteringsforslag',
            operation: isAdded ? 'Add_Values' : 'Update_Values',
            id: konteringsforslagId,
            values: values,
          },
          {
            associationName: `Kontodel${lopnr}`,
            operation: 'Ref',
            values:
              newValue === ''
                ? null
                : {
                    id: wantedKoddel?.id ?? null,
                    KONTODEL: wantedKoddel?.kontodel ?? newValue,
                    BENAMNING: wantedKoddel?.benamning ?? 'saknas',
                  },
          },
        ]);
      }
    },
    [formContext, konteringContext]
  );

  const isKontodelChanged = useCallback(
    (
      konteringsforslag: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Konteringsforslag_All,
      currentKontodelId: string,
      lopnr: number
    ) => {
      const old: string | undefined = formContext?.data._Associations?.[
        'Faktura'
      ]?.['_Associations']?.['Konteringsforslag_All']?.find(
        (x: TEDInputLRKonteringsForslagUpdateValues) =>
          x.id === konteringsforslag.id
      )?.['_Associations']?.[`Kontodel${lopnr}`]?.id;
      return !old || old !== currentKontodelId;
    },

    [formContext]
  );

  const iAmStandin = useCallback(
    (userSign: string): IStandinInfo | null => {
      const fromAttestMinaStatusToAttestTyp = (
        attestMinaStatus: TEDLRFakturaDelAttestMinaStatusEnum
      ): TEDLRFakturaAttestTYPEnum | null => {
        switch (attestMinaStatus) {
          case TEDLRFakturaDelAttestMinaStatusEnum.BESLUTSATTESTERAS:
            return TEDLRFakturaAttestTYPEnum.BESLUTSATTEST;
          case TEDLRFakturaDelAttestMinaStatusEnum.MOTTAGNINGSATTESTERAS:
            return TEDLRFakturaAttestTYPEnum.MOTTAGNINGSATTEST;
        }

        return null;
      };

      const fakturaAttest =
        dataMergedWithChanges?._Associations?.Fakturaattest?.find(
          (attest: any) =>
            attest?._Associations?.Attestratt?._Associations?.Reserver?.some(
              (reserv: any) =>
                reserv._Associations?.Reserv?._Associations?.Attestant?._Associations?.Anvandare?.SIGNATURE.toLowerCase() ===
                userSign
            ) &&
            attest?.AttestTyp ===
              fromAttestMinaStatusToAttestTyp(
                dataMergedWithChanges?.AttestMinaStatus
              )
        );

      if (fakturaAttest) {
        return {
          attestOmradeId:
            fakturaAttest._Associations?.Attestratt?._Associations?.Attestomrade
              ?.id ?? '',
          reserv: true,
          reservFor: fakturaAttest,
          typ: fakturaAttest.AttestTyp,
        };
      }

      return null;
    },
    [
      dataMergedWithChanges?.AttestMinaStatus,
      dataMergedWithChanges?._Associations?.Fakturaattest,
    ]
  );

  const handleAttesteraWithShortcut = useCallback(() => {
    const isAttesteraBtnDisabled = isAttesteraButtonDisabled(
      formContext,
      konteringContext.konteringValidationQueryLoading
    );
    if (!isAttesteraBtnDisabled) {
      setHaveAttesterat(true);
      attesteraFakturadel(
        formContext,
        loginStateContext.sign,
        reservForContext.reservForData
      );
    }
  }, [
    setHaveAttesterat,
    formContext,
    konteringContext.konteringValidationQueryLoading,
    loginStateContext.sign,
    reservForContext.reservForData,
  ]);

  const handleSaveWithShortcut = useCallback(() => {
    const isSaveBtnDisabled = isSaveButtonDisabled(
      formContext,
      konteringContext.konteringValidationQueryLoading
    );

    if (!isSaveBtnDisabled) {
      setMessageEditModeID('');
      formContext?.saveForm(undefined, () => {
        formStateDispatch?.({ type: 'VALIDATE' });
      });
    }
  }, [
    setMessageEditModeID,
    formContext,
    konteringContext.konteringValidationQueryLoading,
    formStateDispatch,
  ]);

  const handleUndoShortcut = useCallback(() => {
    const isDisabled = isUndoFakturaAttestButtonDisabled(formContext);
    if (!isDisabled) {
      /*
        TODO: 
        När GR tar bort  editMenuOnCancel: (() => void) | undefined från IEditMenuActionParams
        så behöver vi inte skicka in undefined. Ta bort undefined och uppdatera params i undoFakturaAttest.
      */
      undoFakturaAttest(formContext, undefined);
    }
  }, [formContext]);

  const calculatedFakturaAmount =
    dataMergedWithChanges?.FakturaBelopp2 -
    (dataMergedWithChanges?._Associations?.Faktura?.MomsBelopp2 ?? 0);

  const value: IFakturaDelContext = useMemo(
    () => ({
      activeKF,
      addAttestMessage,
      getAttestMessageUpdateValue,
      addFakturaattest,
      addOrUpdateKonteringsforslag,
      getAllAttestanter,
      getAttestanter,
      allAttestanterOnAllParts,
      attestMessages,
      bokfDatum: new Date(
        formContext?.data?._Associations?.Faktura?._Associations?.Registrering?._Associations?.Bokfverifikationer?.DATUM
      ),
      deleteOrUndoAttestMessage,
      deleteFakturaattest,
      deleteKonteringsforslag,
      deletedKFs: deletedKFs ?? [],
      fakturaBelopp: calculatedFakturaAmount,
      fakturaId: dataMergedWithChanges?._Associations?.Faktura?.id,
      kodplanId:
        formContext?.data?._Associations?.Faktura?._Associations?.Registrering
          ?._Associations?.Bokfverifikationer?._Associations?.Kodplan?.id ?? '',
      konteringsforslag,
      getAktuellFakturadel,
      getFakturadel,
      getOriginKonteringsforslag,
      minFakturaAttest,
      setActiveKF,
      setBeslutsattestant,
      isBeslutsattestantChanged,
      isKobFaktura,
      setBelopp,
      setBeloppExklMoms,
      getBeloppInklMomsFormValue,
      getKostnadsBeloppFormValue,
      getKostnadsBelopp,
      isBeloppChanged,
      setKontodel,
      isKontodelChanged,
      beslutsattestByKonteringsforslag,
      beslutsAttestanterAllaFakturadelar,
      iAmStandin,
      innehallerFleraFakturadelar,
      jagAttesterar,
      readMessage,
    }),
    [
      activeKF,
      addAttestMessage,
      getAttestMessageUpdateValue,
      addFakturaattest,
      addOrUpdateKonteringsforslag,
      getAllAttestanter,
      getAttestanter,
      allAttestanterOnAllParts,
      attestMessages,
      formContext?.data?._Associations?.Faktura?._Associations?.Registrering
        ?._Associations?.Bokfverifikationer?.DATUM,
      formContext?.data?._Associations?.Faktura?._Associations?.Registrering
        ?._Associations?.Bokfverifikationer?._Associations?.Kodplan?.id,
      deleteOrUndoAttestMessage,
      deleteFakturaattest,
      deleteKonteringsforslag,
      deletedKFs,
      calculatedFakturaAmount,
      dataMergedWithChanges?._Associations?.Faktura?.id,
      konteringsforslag,
      getAktuellFakturadel,
      getFakturadel,
      getOriginKonteringsforslag,
      minFakturaAttest,
      setActiveKF,
      setBeslutsattestant,
      isBeslutsattestantChanged,
      isKobFaktura,
      setBelopp,
      setBeloppExklMoms,
      getBeloppInklMomsFormValue,
      getKostnadsBeloppFormValue,
      isBeloppChanged,
      setKontodel,
      isKontodelChanged,
      beslutsattestByKonteringsforslag,
      beslutsAttestanterAllaFakturadelar,
      iAmStandin,
      innehallerFleraFakturadelar,
      jagAttesterar,
      readMessage,
    ]
  );

  return (
    <FakturadelContext.Provider value={value}>
      <EDKeybind alt global keymap="a" onKeyDown={handleAttesteraWithShortcut}>
        <EDKeybind alt global keymap="s" onKeyDown={handleSaveWithShortcut}>
          <EDKeybind alt global keymap="z" onKeyDown={handleUndoShortcut}>
            {props.children}
          </EDKeybind>
        </EDKeybind>
      </EDKeybind>
    </FakturadelContext.Provider>
  );
};

export default FakturaDelContextManager;
